<template>
<div>
  <v-card-actions
    class="justify-center"
    style="background-color: white"
  >
      <v-btn
      dark
      tile
      unelevated
      x-large
      depressed
      color="primary"
      style="width: 100%; height: 80px; font-size: 30px;"
      @click="$emit('vote-npo')"
      >{{bodyProps.label}}</v-btn>
        
  </v-card-actions>
  <v-card-text
    v-if="bodyProps.campaign.vote_description"
    class="pa-4 px-8 text-center text-body-2">
    {{bodyProps.campaign.vote_description}}
  </v-card-text>
  </div>
</template>

<script>
export default {
  props: {
    bodyProps: {
      type: Object,
      default () {
        return {
          label: 'Scegli e vota'
        }
      }
    }
  }
}
</script>
<style>
</style>
